import React, { useState } from "react"
import PropTypes from "prop-types"

import styles from "./Options.module.scss"
import { sendGTMEvent } from "../../utils/googleAnalytics"

const Options = ({
    quesId,
    handleClick,
    option1,
    option2,
    option3,
    option4,
    number,
    index,
}) => {
    const options = [
        option1.label,
        option2.label,
        option3?.label,
        option4?.label,
    ]
    const [selectedOption, setSelectedOption] = useState("")

    const handleSelectedOption = ans => {
        setSelectedOption(quesId + ans)
    }

    return (
        <>
            {options.map(option => {
                if (option) {
                    const selectedOptionStyle =
                        quesId + option === selectedOption
                            ? styles.ansSelected
                            : ""

                    return (
                        <li
                            key={quesId + option}
                            className={selectedOptionStyle}
                        >
                            <button
                                type="button"
                                onClick={e => {
                                    sendGTMEvent(
                                        "widget answer click",
                                        `question number=${number}`
                                    )
                                    handleClick(e.target.value, quesId, index)
                                    handleSelectedOption(option)
                                }}
                                value={`option${options.indexOf(option) + 1}`}
                                className={styles.ansButton}
                            >
                                {option}
                            </button>
                        </li>
                    )
                }
                return ""
            })}
        </>
    )
}

Options.defaultProps = {
    option3: null,
    option4: null,
}

Options.propTypes = {
    quesId: PropTypes.string.isRequired,
    handleClick: PropTypes.func.isRequired,
    index: PropTypes.number.isRequired,
    option1: PropTypes.shape({
        results: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
    }).isRequired,
    option2: PropTypes.shape({
        results: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
    }).isRequired,
    option3: PropTypes.shape({
        results: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
    }),
    option4: PropTypes.shape({
        results: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
    }),
}

export default Options
